/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Iconik_Publish_Markers_Failed_ToastInputs */



/**
* | output |
* | --- |
* | "Subtitles published, but marker publish failed: {error}" |
*
* @param {Iconik_Publish_Markers_Failed_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const iconik_publish_markers_failed_toast = /** @type {((inputs: Iconik_Publish_Markers_Failed_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iconik_Publish_Markers_Failed_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Subtitles published, but marker publish failed: ${i?.error}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Subtitles published, but marker publish failed: ${i?.error}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Subtitles published, but marker publish failed: ${i?.error}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Subtitles published, but marker publish failed: ${i?.error}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Subtitles published, but marker publish failed: ${i?.error}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`Subtitles published, but marker publish failed: ${i?.error}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`Subtitles published, but marker publish failed: ${i?.error}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`Subtitles published, but marker publish failed: ${i?.error}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Subtitles published, but marker publish failed: ${i?.error}`)
	return /** @type {LocalizedString} */ (`Subtitles published, but marker publish failed: ${i?.error}`)
});